import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  customerUsageList: [],
  customerUsage: undefined,
  listLoading: false,
  actionsLoading: false,
  error: null,
  countCustomerUsage: 0,
  currentCustomerUsage: undefined,
  userActiveTrend: [],
  userActivityTrend: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const slice = createSlice({
  name: "customerSuccessCustomerUsage",
  initialState: initialState,
  reducers: {
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    
    customerUsagesFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.customerUsageList = data.data;
      state.countCustomerUsage = data.totalCount;
    },

    customerUsageFetched: (state, action) => {
      state.actionsLoading = false;
      state.customerUsage = action.payload.data;
      state.error = null;
    },

    customerUsageDetailFetched: (state, action) => {
      state.actionLoading = false;
      state.error = null;
      state.currentCustomerUsage = action.payload.data.data;
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    userActiveTrendFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.userActiveTrend = action.payload.data.data;
    },

    userActivityTrendFetched: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.userActivityTrend = action.payload.data.data;
    },
  }
}); 
